import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaCodeBranch } from "react-icons/fa";

const matchLabels = {
  contains: "Contains",
  exact: "Exact match",
  startsWith: "Starts with",
  regex: "Regex",
};

export default function ConditionNode({ data, selected }) {
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[200px] transition-shadow ${
        selected ? "border-purple-500 shadow-md" : "border-surface-border"
      }`}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-purple-500 !border-2 !border-white"
      />

      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-purple-500">
        <FaCodeBranch size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Condition</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5">
        {(() => {
          const list = Array.isArray(data.keywords)
            ? data.keywords
            : (typeof data.keyword === "string" && data.keyword.trim()
                ? data.keyword.split(",").map((k) => k.trim().replace(/^["']|["']$/g, "")).filter(Boolean)
                : []);
          if (list.length === 0) {
            return <p className="text-xs text-ink-muted italic">Click to configure</p>;
          }
          return (
            <>
              <p className="text-2xs text-ink-muted mb-0.5">
                If message {(matchLabels[data.matchType] || "contains").toLowerCase()}
              </p>
              <p className="text-xs font-medium text-ink-primary truncate">
                {list.slice(0, 3).map((k) => `"${k}"`).join(", ")}
                {list.length > 3 ? ` +${list.length - 3} more` : ""}
              </p>
            </>
          );
        })()}
      </div>

      {/* Yes / No output handles */}
      <div className="flex justify-between px-3 pb-2">
        <div className="flex items-center gap-1">
          <span className="text-2xs font-medium text-green-600">Yes</span>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-2xs font-medium text-red-500">No</span>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        id="yes"
        className="!w-3 !h-3 !bg-green-500 !border-2 !border-white"
        style={{ left: "30%" }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="no"
        className="!w-3 !h-3 !bg-red-500 !border-2 !border-white"
        style={{ left: "70%" }}
      />
    </div>
  );
}
